// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"03e11015","272":"00398c20","453":"696006ab"}[chunkId] + ".chunk.js";
};